import { useState } from 'react';
import { FeedbackData } from '../types';
import { feedbackOptions } from '../utils/constants';
const BASE_URL = import.meta.env.VITE_API_URL + '/pytask_api';
export const useFeedback = (userId: number | null, problemId: number | null, onFeedbackSubmitted: () => void) => {
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);
  const [feedback, setFeedback] = useState({
    theme: '',
    concepts: '',
    comprehensible: '',
    difficulty: '',
    interestingness: '',
    comments: ''
  });
  const [feedbackError, setFeedbackError] = useState('');

  const handleFeedbackChange = (name: string, value: string) => {
    setFeedback(prev => ({ ...prev, [name]: value }));
    setFeedbackError('');
  };

  const isFormValid = () => {
    return (
      feedback.theme !== '' &&
      feedback.concepts !== '' &&
      feedback.comprehensible !== '' &&
      feedback.difficulty !== '' &&
      feedback.interestingness !== ''
    );
  };

  const getFeedbackValue = (category: string, label: string): number => {
    const option = feedbackOptions[category as keyof typeof feedbackOptions].find(
      opt => opt.label === label
    );
    return option ? option.value : 0.0;
  };

  const submitFeedback = async (e?: React.FormEvent) => {
    if (e) e.preventDefault();
    
    if (!isFormValid()) {
      setFeedbackError('All ratings are required!');
      return;
    }

    if (!userId || !problemId) {
      setFeedbackError('Invalid user_id or problem_id');
      return;
    }

    const feedbackData: FeedbackData = {
      user: userId,
      problem: problemId,
      context_satisfaction: getFeedbackValue('theme', feedback.theme),
      concepts_satisfaction: getFeedbackValue('concepts', feedback.concepts),
      comprehensible: getFeedbackValue('comprehensible', feedback.comprehensible),
      difficulty: getFeedbackValue('difficulty', feedback.difficulty),
      interestingness: getFeedbackValue('interestingness', feedback.interestingness),
      comments: feedback.comments
    };

    try {
      const response = await fetch(`${BASE_URL}/submitfeedback/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(feedbackData)
      });

      if (!response.ok) {
        throw new Error(await response.text());
      }

      setIsFeedbackModalOpen(false);
      setFeedback({
        theme: '',
        concepts: '',
        comprehensible: '',
        difficulty: '',
        interestingness: '',
        comments: ''
      });
      onFeedbackSubmitted();
      return response.json();
    } catch (error) {
      console.error('Failed to submit feedback:', error);
      setFeedbackError(`Failed to submit feedback: ${error instanceof Error ? error.message : 'Unknown error'}`);
      throw error;
    }
  };

  return {
    feedback,
    feedbackError,
    isFeedbackModalOpen,
    setIsFeedbackModalOpen,
    handleFeedbackChange,
    submitFeedback
  };
};